import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Typography, Button, Grid } from "@mui/material";
import Modal from "../../../../components/Modal/Modal";
import { useTranslation } from "react-i18next";
import OnlineCourseForm from "../../../../components/Forms/OnlineCourseForm";
import { makeGetEntities } from "../../../../redux/selectors/selectors";

const selector = makeGetEntities();

const AddCourseVersionModalForm = ({
  submitForm,
  onClose,
  open,
  isSubmitting,
  courseTitle,
  resetForm,
  formFields
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    resetForm();
  }, [open]);

  return (
    <Modal
      maxWidth="sm"
      fullWidth
      dialogTitle={
        <Typography variant="h4" color="textPrimary">
          {`${courseTitle}: ${t("manageCourses.courseVersionsAddNewTitle")}`}
        </Typography>
      }
      dialogContent={
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {formFields.name}
          </Grid>
          <Grid item xs={12}>
            {formFields.description}
          </Grid>
          <Grid item xs={12} sm={6}>
            {formFields.language}
          </Grid>
          <Grid item xs={12} sm={6}>
            {formFields.status}
          </Grid>
          <Grid item xs={12} sm={6}>
            {formFields.trainingHours}
          </Grid>
          <Grid item xs={12} sm={6}>
            {formFields.trainingMinutes}
          </Grid>
        </Grid>
      }
      dialogActions={
        <>
          <Button color="primary" disabled={isSubmitting} onClick={onClose}>
            {t("manageCourses.courseVersionsAddNewCancelBtn")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={submitForm}
            disabled={isSubmitting}
          >
            {t("manageCourses.courseVersionsAddNewSubmitBtn")}
          </Button>
        </>
      }
      open={open}
      onClose={onClose}
      scrollable
    />
  );
};

const AddCourseVersionModal = ({ onClose, open, onSubmit, courseId }) => {
  const { courseSettings } = useSelector(({ contentCoursesState }) => ({
    courseSettings: selector(contentCoursesState, {
      type: "courseSettings",
      id: courseId
    })
  }));

  const courseTitle = courseSettings ? courseSettings.name : "";
  const courseDescription = courseSettings ? courseSettings.description : "";
  const courseHours = courseSettings ? courseSettings.durationHours : 0;
  const courseMinutes = courseSettings ? courseSettings.durationMinutes : 0;

  return (
    <OnlineCourseForm
      initialValues={{
        name: courseTitle,
        trainingHours: courseHours,
        trainingMinutes: courseMinutes,
        language: "English",
        status: "Active",
        description: courseDescription
      }}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        onSubmit(values);
      }}
      render={({
        formFields,
        formikProps: { resetForm, submitForm, isSubmitting }
      }) => (
        <AddCourseVersionModalForm
          submitForm={submitForm}
          isSubmitting={isSubmitting}
          resetForm={resetForm}
          open={open}
          onClose={onClose}
          courseTitle={courseTitle}
          formFields={formFields}
        />
      )}
    />
  );
};

AddCourseVersionModal.propTypes = {
  /**
   * Called to close the Add Course Version Modal
   */
  onClose: PropTypes.func,
  /**
   * True if the modal is open, false otherwise
   */
  open: PropTypes.bool,
  /**
   * Called when the form is submitted to create the new version
   */
  onSubmit: PropTypes.func
};

export default AddCourseVersionModal;
